import { render, staticRenderFns } from "./DialogEdoklady.vue?vue&type=template&id=bff823ee"
import script from "./DialogEdoklady.vue?vue&type=script&lang=ts"
export * from "./DialogEdoklady.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports